export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5239.e3913996.jpg";